import { ProgressFlags } from './progress'
import { getDefaultStore } from 'jotai'
import { selectedProgramType } from '@/page/Onboarding/ProgramTypeSelection/data'

export function getNextStepUrl(flags: number) {
  const store = getDefaultStore()
  const programType = store.get(selectedProgramType)
  if ((flags & ProgressFlags.PROFILE_INIT) === 0) {
    return '/onboarding/personal-info'
  } else if ((flags & ProgressFlags.ADDR_FILLED) === 0) {
    return '/onboarding/user-addr'
  } else if ((flags & ProgressFlags.EDU_HISTORY_FILLED) === 0) {
    return programType ? '/onboarding/edu-info' : '/onboarding/program-type-selection'
  } else if ((flags & ProgressFlags.JOB_PREFS_SELECTED) === 0) {
    return '/onboarding/basic-job-application-info'
  } else if ((flags & ProgressFlags.INTERESTS_SELECTED) === 0) {
    return '/onboarding/interest'
  } else {
    return undefined
  }
}
